// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"0849d5c8","276":"5256ac01","662":"f6e1e545","920":"d3f20589","931":"5256ac01"}[chunkId] + ".chunk.css";
};